@if (mode === 'sideWithShadow' || mode === 'bottom') {
  <div
    class="outer"
  [ngClass]="{
    'collapsed-mobile-outer':
      (mode === 'bottom' || mode === 'sideWithShadow') && !toggled
  }"
    (click)="mode === 'bottom' ? collapseMobileNav() : null"
  ></div>
}
<nav
  id="nav-sidebar"
  #nav
  [ngClass]="{
    expanded: toggled,
    shadow: true
  }"
  tabindex="0"
  >
  <div class="chevron-container">
    @if (mode === 'bottom') {
      <bolt-icon
        (click)="collapseMobileNav()"
        name="xmark"
        color="black"
        [attr.id]="'closeDelete'"
        size="sm"
        title="collapse"
      ></bolt-icon>
    }
    @if (mode === 'sideWithShadow' || mode === 'side') {
      <bolt-icon
        (click)="toggleSidebar()"
        name="chevron-right"
        color="black"
        [attr.id]="'chevron'"
        size="sm"
        [ngClass]="{ rotate: toggled }"
        title="toggle"
      ></bolt-icon>
    }
  </div>
  <div class="home-container">
    <button
      #homeContainer
      class="home-container-button"
      (click)="showNewQuoteModal()"
      >
      <img
        class="img-svg"
        src="{{ HomePage.icon }}"
        alt="{{ HomePage.name }}"
        />
        <p
          #sidebarText
          class="home-text link"
          [ngClass]="{ invisible: !toggled }"
          >
          Start a new quote
        </p>
      </button>
    </div>
    <hr />
    <div #sidebarContent class="sidebar-content">
      @for (page of pages$ | async; track trackPage($index, page)) {
        <a
          href="javascript:void(0)"
      [ngClass]="{
        step: true,
        shrunk: !toggled,
        active: page.id === currentPage?.id,
        locked:
          !page.isNavigable ||
          pageShouldLockWithoutQuoteId(products$ | async, page) ||
          pageShouldLockForProtectorVersionChoice(
            this.awaitingProtectorVersionChoice$ | async,
            currentPage
          )
      }"
          (click)="navigationDesired(page)"
          id="nav-sidebar-step-{{ page.id }}"
          >
          @if (page.icon) {
            <img
              class="img-svg"
              src="{{ page.icon }}"
              alt="{{ page.name + ' icon' }}"
              />
          }
          @if (page.isComplete && page.isNavigable) {
            <img
              class="faux-feedback-icon complete-icon complete-img"
              name="faux-bolt-success"
              src="/assets/images/nav-bar/completed-checkmark.svg"
              alt="completed image icon"
              />
          }
          <p #sidebarText class="link" [ngClass]="{ invisible: !toggled }">
            {{ page.name }}
          </p>
          @if (page.id !== 'HUB' && pageErrorMap[page.name] && page.isNavigable) {
            <img
              class="faux-feedback-icon error-img"
              name="faux-bolt-error"
              src="/assets/images/nav-bar/exclamation-circle-filled.svg"
              alt="error image icon"
              />
          }
          @if (!page.isNavigable) {
            <bolt-icon
              class="feedback-icon"
              name="lock-closed"
              color="gray"
              size="sm"
            ></bolt-icon>
          }
          @if (
            (page.id === 'HUB' || (hubPageLoaded$ | async)) &&
            !pageErrorMap[page.name] &&
            (page.hasWarning || page.hasReviewWarning) &&
            page.isNavigable
            ) {
            <bolt-icon
              class="feedback-icon"
              name="exclamation-triangle-filled"
              color="theme-warning"
              size="sm"
            ></bolt-icon>
          }
        </a>
      }
      @if (doAnyProductsHaveBindSuspension(products$ | async)) {
        <div [ngClass]="{ hide: toggled }">
          <img
            class="faux-feedback-icon info-img"
            name="faux-bolt-info-icon"
            src="/assets/images/nav-bar/icon-bind-suspension.svg"
            (mouseenter)="onErrorHover()"
            (mouseleave)="onErrorHover()"
            alt="error icon"
            />
          </div>
          <div
        [ngClass]="{
          'nwx-card-darkSeaBlue': true,
          hide: shouldBindSuspensionBeHidden(),
          'hover-position': hovering
        }"
            >
            <div class="bolt-typography nwx-card-header">
              <bolt-icon
                name="notification-error"
                size="sm"
                style="position: relative; top: 3px"
                color="white"
              ></bolt-icon>
              &nbsp;&nbsp;Bind Suspension
            </div>
            <div class="nwx-card-body">
              @for (product of products$ | async; track product.type) {
                @if (product.hasBindSuspension) {
                  <p class="product-heading">
                    <img
                      class="product-heading-img-svg"
                      src="{{ getProductIcon(product.type, pages$ | async) }}"
                      alt="{{ product.name + ' icon' }}"
                      />&nbsp;{{ product.name }}
                    </p>
                  }
                }
                <div class="product-heading-divider"></div>
                <p class="suspension-text">{{ bindSuspensionMessage }}</p>
              </div>
            </div>
          }
          <div class="help-container-divider"></div>
          <a
            href="javascript:void(0)"
      [ngClass]="{
        step: true,
        shrunk: !toggled,
        locked: accountInfoLocked
      }"
            (click)="showAccountInfoModal()"
            >
            <img
              class="img-svg"
              [border]="0"
              src="{{ AccountInfoPage.icon }}"
              alt="{{ AccountInfoPage.name + ' icon' }}"
              />
              <p
                #sidebarText
                class="link help-link"
                [ngClass]="{ invisible: !toggled }"
                >
                Account information
              </p>
            </a>
            <a
              href="javascript:void(0)"
      [ngClass]="{
        step: true,
        shrunk: !toggled,
        locked: !HelpPage.isNavigable
      }"
              (click)="showHelpModal()"
              >
              <img
                class="img-svg help-svg"
                [border]="0"
                src="{{ HelpPage.icon }}"
                alt="{{ HelpPage.name + ' icon' }}"
                />
                <p
                  #sidebarText
                  class="link help-link"
                  [ngClass]="{ invisible: !toggled }"
                  >
                  Help
                </p>
              </a>
            </div>
          </nav>
